module.exports = __webpack_public_path__ + "static/media/16.0b93c98a.jpg";